<template>
  <el-dialog
      :title="titleChannelName"
      :visible="show"
      @close="closeDialog"
      :close-on-click-modal="false"
      width="1750px"
  >
    <div class="child">
      <el-table :data="value"
                highlight-current-row>
        <el-table-column
            width="140px"
            prop="merchantName"
            :label="$t('text.merchantName')"
            align="center"
        ></el-table-column>
        <el-table-column
            width="180px"
            prop="appId"
            :label="$t('text.appId')"
            align="center"
        ></el-table-column>

        <el-table-column prop="" width="30px" label="|" align="center">|</el-table-column>

        <el-table-column
            width="140px"
            prop="totalAmount"
            :formatter="$formatter.FenToYuanToThousandth"
            :label="$t('text.transactionAmount')"
            align="center"
        ></el-table-column>

        <el-table-column
            width="80px"
            prop="iftFeeRate"
            :label="$t('text.iftFeeRate')"
            align="center"
        ></el-table-column>

        <el-table-column
            width="140px"
            prop="iftAmount"
            :formatter="$formatter.FenToYuanToThousandth"
            :label="$t('text.iftAmount')"
            align="center"
        ></el-table-column>

        <el-table-column
            width="100px"
            prop="ibftFeeRate"
            :label="$t('text.ibftFeeRate')"
            align="center"
        ></el-table-column>

        <el-table-column
            width="140px"
            prop="ibftAmount"
            :formatter="$formatter.FenToYuanToThousandth"
            :label="$t('text.ibftAmount')"
            align="center"
        ></el-table-column>

        <el-table-column prop="" width="30px" label="|" align="center">|</el-table-column>

        <el-table-column
            width="140px"
            prop="paymentFee"
            :formatter="$formatter.FenToYuanToThousandth"
            :label="$t('text.channelCost')"
            align="center"
        ></el-table-column>

        <el-table-column
            width="110px"
            prop="paymentCount"
            :label="$t('text.transactionCount')"
            align="center"
        ></el-table-column>
        <el-table-column
            width="120px"
            prop="paymentCountSuccess"
            :label="$t('text.transactionSuccessCount')"
            align="center"
        ></el-table-column>
        <el-table-column
            width="110px"
            prop="paymentCountSuccessRate"
            :label="$t('text.transactionSuccessRate')"
            align="center"
        ></el-table-column>

        <el-table-column prop="" width="30px" label="|" align="center">|</el-table-column>

        <el-table-column
            width="160px"
            prop="channelAgentName"
            :label="$t('text.channelAgentName')"
            align="center"
        ></el-table-column>

        <el-table-column
            width="120px"
            prop="channelAgentRate"
            :label="$t('text.channelAgentRate')"
            align="center"
        ></el-table-column>

        <el-table-column
            width="140px"
            prop="channelAgentFee"
            :formatter="$formatter.FenToYuanToThousandth"
            :label="$t('text.channelAgentFee')"
            align="center"
        ></el-table-column>

        <el-table-column
            width="140px"
            prop="merchantAgentFee"
            :formatter="$formatter.FenToYuanToThousandth"
            :label="$t('text.merchantAgentFee')"
            align="center"
        ></el-table-column>

        <el-table-column prop="" width="30px" label="|" align="center">|</el-table-column>

        <el-table-column
            width="140px"
            prop="merFee"
            :formatter="$formatter.FenToYuanToThousandth"
            :label="$t('text.merchantFee')"
            align="center"
        ></el-table-column>

        <el-table-column
            width="140px"
            prop="calBalance"
            :formatter="$formatter.FenToYuanToThousandth"
            :label="$t('text.profit')"
            align="center"
        ></el-table-column>

        <el-table-column
            width="140px"
            prop="quota"
            :formatter="$formatter.FenToYuanToThousandth"
            :label="$t('text.quota')"
            align="center"
        ></el-table-column>

        <el-table-column
            width="110px"
            prop="quotaUsageRate"
            :label="$t('text.quotaUsageRate')"
            align="center"
        ></el-table-column>
      </el-table>
    </div>

  </el-dialog>
</template>

<script>
import page from "@/components/Page.vue";

export default {
  name: "channelEdit",
  components: {page},
  props: {
    show: Boolean,
    value: Array,
    titleChannelName: '',
    channelOption: Array
  },
  data() {
    return {
      editedTitleChannelName: '',
      dialogShow: this.show,
      groups: "",
      isButton: true,
      isDisabled: false,
      form: [],
      formLabelWidth: "140px",
      rules: {}
    };
  },
  created() {

  },
  methods: {
    closeDialog() {
      this.$emit("update:show", false);
    },
  },
  mounted() {
  }
};
</script>
